<nscf-title [title]="data.title" />
<effy-liseret />
<p class="mb-12">{{ data.chapo }}</p>

@if (data.products.length) {
  <nscf-carousel [class.hidden]="!isBrowser" [mediasCarouselItems]="data.products" [settings]="responsiveSettings">
    <ng-template let-product="slide" let-stepNumber="stepNumber">
      <div class="flex flex-col gap-y-2 max-w-[312px] p-4 smd:p-6 border-border-card border-[1px] shadow-level-1 rounded-xl">
        <div class="relative h-[40px]">
          <img class="object-contain object-left" [ngSrc]="product.logo.url" fill priority="false" [attr.alt]="product.logo.alt" />
        </div>
        <div class="relative mx-auto size-[148px] smd:size-[200px]">
          <img class="object-contain object-center" [ngSrc]="product.image.webpUrl" fill priority="false" [attr.alt]="product.image.alt" />
        </div>
        <p class="one-line-text font-600 text-md smd:text-lg">{{ product.name }}</p>
        <div class="one-line-text font-300 text-xs smd:text-sm text-article-blue" [innerHTML]="product.description"></div>
        <p class="font-600 text-2xl smd:text-3xl">{{ product.price | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</p>
        @let ctaUrl = product.ctaUrl;
        <a
          effy-button
          class="w-full"
          [color]="buttonStyle"
          [attr.href]="ctaUrl.url"
          [attr.rel]="ctaUrl?.options?.attributes?.rel"
          [attr.target]="ctaUrl?.options?.attributes?.target"
          [attr.id]="clickId"
          [ngClass]="ctaUrl?.options?.attributes?.class"
          >{{ ctaUrl.title }}</a
        >
      </div>
    </ng-template>
  </nscf-carousel>
}
